import { useEffect, Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';

import { sendLinePostback } from './utils/LinePostbackActions';

const PostbackPage = () => {
  const [searchParams] = useSearchParams();
  const liffState = searchParams.get('liff.state');
  const directToken = searchParams.get('token');

  useEffect(() => {
    const sendPostback = async () => {
      try {
        let token;

        if (liffState) {
          const decodedState = decodeURIComponent(liffState);
          const urlParams = new URLSearchParams(decodedState);
          token = urlParams.get('token');
        } else {
          token = directToken;
        }

        if (!token) {
          alert('Token is missing in the URL parameters');
          return;
        }

        const response = await sendLinePostback({ token });
        if (!response.success) {
          alert(response.message);
          return;
        }

        if (response?.data?.redirect_url) {
          window.location.href = response.data.redirect_url;
        }

        if (response?.data?.message) {
          alert(response.data.message);
        }
      } catch (err) {
        console.error(err);
        alert(`Error occurred while connect to server`);
      }
    };

    sendPostback();
  }, [liffState, directToken]);

  return <Fragment />;
};

export default PostbackPage;
